import React, { useState, useContext } from "react";
// Material -ui v4

import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSort,
  faSortUp,
  faSortDown,
} from "@fortawesome/free-solid-svg-icons";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import PropTypes from "prop-types";
import AuthContext from "contexts/AuthProvider.js";
import { useTranslation } from "react-i18next";
import OnePage from "views/InitiativesProgram/OnePage.js";
import styles from "../../../../assets/jss/material-dashboard-pro-react/views/initiativesManagementStyle.js";
import moment from "moment";
import {
  buildHierarchyFromInitiatives,
  sortDataRecursively,
} from "../../../../../src/utils/hierarchyUtils";

// =============== Adicione se necessário ===============
// import Tippy from "@tippyjs/react";
// import "tippy.js/dist/tippy.css"; //se usar tippy
// import { Button } from "@material-ui/core"; //se quiser um outro tipo de Button
// ======================================================

// Circle size in the header

const circleSize = 30;

// ======= Your mocks used for the table (example) =======
// [Replace full mock]

// If you are using the same file or context as overviewtable,
// Just change the array for the version below.

const flatInitiatives = [
  {
    id: 1,
    branch: "Cliente no Centro",
    workfront: "Pós Vendas",
    initiativeName: "Implementação novo Processo de Pós Vendas",
    status: "green",
    helpRequests: [],
    ebitda: 100,
    stage: "Identificação",
  },
  {
    id: 2,
    branch: "Cliente no Centro",
    workfront: "Pós Vendas",
    initiativeName: "Novo mecanismo de medição NPS",
    status: "yellow",
    helpRequests: [
      {
        date: "2025-03-10",
        initiativeName: "Novo mecanismo de medição NPS",
        message: "Precisamos de budget para contratar agência de pesquisa.",
      },
    ],
    ebitda: 50,
    stage: "Sustentação",
  },
  {
    id: 3,
    branch: "Cliente no Centro",
    workfront: "Pós Vendas",
    initiativeName: "Virada de Estrutura",
    status: "green",
    helpRequests: [
      {
        date: "2025-03-12",
        initiativeName: "Virada de Estrutura",
        message: "Aprovação em comitê atrasada.",
      },
    ],
    ebitda: 30,
    stage: "Captura de Resultado",
  },
  {
    id: 4,
    branch: "Cliente no Centro",
    workfront: "Atendimento ao Cliente",
    initiativeName: "Implementação da Nova Rotina Comercial",
    status: "green",
    helpRequests: [],
    ebitda: 80,
    stage: "Ideação",
  },
  {
    id: 5,
    branch: "Cliente no Centro",
    workfront: "Atendimento ao Cliente",
    initiativeName: "Piloto Novo Modelo Comercial",
    status: "green",
    helpRequests: [],
    ebitda: 40,
    stage: "Identificação",
  },
  {
    id: 6,
    branch: "Cliente no Centro",
    workfront: "Atendimento ao Cliente",
    initiativeName: "Implementação Torre de Controle",
    status: "green",
    helpRequests: [
      {
        date: "2025-03-15",
        initiativeName: "Implementação Torre de Controle",
        message: "Falta de desenvolvedores para backlog.",
      },
    ],
    ebitda: 60,
    stage: "Em implementação",
  },
  {
    id: 7,
    branch: "Digitalização",
    workfront: "Produtos Digitais",
    initiativeName: "Dashboards de Rotina Comercial",
    status: "yellow",
    helpRequests: [
      {
        date: "2025-03-18",
        initiativeName: "Dashboards de Rotina Comercial",
        message: "Precisamos de licenças de software.",
      },
    ],
    ebitda: 90,
    stage: "Em implementação",
  },
  {
    id: 8,
    branch: "Digitalização",
    workfront: "Produtos Digitais",
    initiativeName: "Novo App para Cliente Final",
    status: "red",
    helpRequests: [
      {
        date: "2025-03-20",
        initiativeName: "Novo App para Cliente Final",
        message: "Integração com sistemas legado bloqueada.",
      },
    ],
    ebitda: 120,
    stage: "Em implementação",
  },
  {
    id: 9,
    branch: "Digitalização",
    workfront: "Área de Analytics",
    initiativeName: "Desenho da Área Analytics",
    status: "green",
    helpRequests: [],
    ebitda: 70,
    stage: "Captura de Resultado",
  },
  {
    id: 10,
    branch: "Digitalização",
    workfront: "Área de Analytics",
    initiativeName: "Processo Seletivo dos Profissionais",
    status: "yellow",
    helpRequests: [
      {
        date: "2025-03-22",
        initiativeName: "Processo Seletivo dos Profissionais",
        message: "Falta de candidatos qualificados.",
      },
    ],
    ebitda: 50,
    stage: "Em implementação",
  },
];

// --------------------------------------------------------

// ============================ OnePage Mocks ============================

const onePageInfoMock = [
  {
    id: 1,
    status: "green",
    date: "2025-01-05",
    km: "<p><strong>Optimized logistics efficiency by 15%</strong></p>",
    next_steps: "<ul><li>Finalize Q1 report</li></ul>",
    risks: "<p>Potential delays due to weather conditions.</p>",
    help_requests: "<p>Need extra team support.</p>",
    approved: "yes",
    comment: "Implement green KPIs",
    reviewed: false,
    reviewedSection: "",
  },
];

const onePageHistoryMock = [
  { id: 1, dates: ["2025-01-05"] },
  { id: 2, dates: ["2025-01-05"] },
  { id: 3, dates: ["2025-01-05"] },
];

export const getLatestOnePageDate = (
  initiativeId,
  sectionStartDate,
  sectionEndDate,
  historyMock,
) => {
  const record = historyMock.find((h) => h.id === initiativeId);
  if (!record) return "";
  return record.dates[0] || "";
};

// ============================ Mounts hierarchy for table ============================

const mockData = buildHierarchyFromInitiatives(flatInitiatives);

// ============================ Row Recursive of the table ===========================

function Row({ row, classes, level = 0, onOpenOnePage }) {
  const [open, setOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleAnimationEnd = () => {
    // If it is a leaf node (without Children) and is hovered, fires onopenonepage

    if ((!row.children || row.children.length === 0) && isHovered) {
      onOpenOnePage(row);
    }
  };

  return (
    <>
      <TableRow>
        {/* Expand Icon */}
        <TableCell>
          {row.children && row.children.length > 0 && (
            <IconButton size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>

        {/* Name Cell With Indenta */}
        <TableCell>
          <span style={{ paddingLeft: level * 16 }}>{row.name}</span>
        </TableCell>

        {/* Number of initiatives */}
        <TableCell align="center">{row.initiatives}</TableCell>

        {/* EBITDA */}
        <TableCell align="right">{row.ebitda} Mi</TableCell>

        {/* HOVER EFFECT STATUS */}
        <TableCell align="center">
          <span
            className={`${classes.hoverCell} ${
              isHovered && (!row.children || row.children.length === 0)
                ? "filling"
                : ""
            }`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onAnimationEnd={handleAnimationEnd}
            style={getStatusStyles(row.status, isHovered)}
          />
        </TableCell>
      </TableRow>

      {row.children && row.children.length > 0 && (
        <TableRow>
          <TableCell colSpan={5} style={{ paddingBottom: 0, paddingTop: 0 }}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <Table size="small" aria-label="child-rows">
                  <TableBody>
                    {row.children.map((child) => (
                      <Row
                        key={child.name}
                        row={child}
                        classes={classes}
                        level={level + 1}
                        onOpenOnePage={onOpenOnePage}
                      />
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
}
Row.propTypes = {
  row: PropTypes.shape({
    name: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    ebitda: PropTypes.number.isRequired,
    initiatives: PropTypes.number.isRequired,
    children: PropTypes.array,
  }).isRequired,
  classes: PropTypes.object.isRequired,
  level: PropTypes.number,
  onOpenOnePage: PropTypes.func.isRequired,
};

// Auxiliary function for circle styles

const getStatusStyles = (status, isHovered) => {
  let baseStyle = {};
  switch (status) {
    case "green":
      baseStyle = {
        background: "linear-gradient(135deg, #66bb6a 0%, #43a047 100%)",
        boxShadow: "0 0 10px rgba(67,160,71,0.4)",
      };
      break;
    case "yellow":
      baseStyle = {
        background: "linear-gradient(135deg, #ffd54f 0%, #ffc107 100%)",
        boxShadow: "0 0 10px rgba(255,193,7,0.4)",
      };
      break;
    case "red":
      baseStyle = {
        background: "linear-gradient(135deg, #ef5350 0%, #e53935 100%)",
        boxShadow: "0 0 10px rgba(229,57,53,0.4)",
      };
      break;
    default:
      baseStyle = {
        background: "linear-gradient(135deg, #bdbdbd 0%, #9e9e9e 100%)",
        boxShadow: "0 0 10px rgba(158,158,158,0.4)",
      };
  }
  return {
    width: circleSize,
    height: circleSize,
    borderRadius: "50%",
    display: "inline-block",
    marginRight: 6,
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    transform: isHovered ? "scale(1.3)" : "scale(1)",
    cursor: "pointer",
    ...baseStyle,
  };
};

// ============================ COMPONENT STAGEOVERVIEW ============================

// Auxiliary function to parse color hex -> [r, g, b]

function parseHexColor(hex) {
  // Removes # If existing

  let c = hex.replace(/^#/, "");
  // Se for formato curto (#abc), duplica os caracteres

  if (c.length === 3) {
    c = c
      .split("")
      .map((ch) => ch + ch)
      .join("");
  }
  const r = parseInt(c.substring(0, 2), 16);
  const g = parseInt(c.substring(2, 4), 16);
  const b = parseInt(c.substring(4, 6), 16);
  return [r, g, b];
}

// Function that returns an alpha between 1.0 (darker) and ex: 0.4 (lighter),
// Depending on the stage index

function getAlphaForStage(index, totalStages) {
  if (totalStages <= 1) return 1;
  const minAlpha = 0.4; // Minimum alpha value for the first stage (lighter)

  const alphaRange = 1 - minAlpha; // difference between 1 and the minimum value

  const step = alphaRange / (totalStages - 1);
  return minAlpha + index * step;
}

function StageOverview({ initiatives }) {
  const { userDetails } = useContext(AuthContext);
  const clientColor = userDetails?.implementation_color || "#2196f3";
  const { t } = useTranslation();

  // 1) List of internships in order

  const orderedStages = [
    "Ideação",
    "Identificação",
    "Em implementação",
    "Captura de Resultado",
    "Sustentação",
  ];

  // 2) Convert Clientcolor to RGB

  const [baseR, baseG, baseB] = parseHexColor(clientColor);

  // 3) Calculate Statistics: Counting and sum of EBITDA for each stage

  const stageStats = React.useMemo(() => {
    const stats = {};
    orderedStages.forEach((st) => {
      stats[st] = { count: 0, totalEbitda: 0 };
    });
    initiatives.forEach((init) => {
      const st = init.stage ? init.stage : "Draft";
      const stageKey =
        orderedStages.find((s) => s.toLowerCase() === st.toLowerCase()) ||
        "Draft";
      stats[stageKey].count++;
      stats[stageKey].totalEbitda += Number(init.ebitda) || 0;
    });
    return stats;
  }, [initiatives, orderedStages]);

  // 4) Determines the highest value (to size the width of the bars)

  const maxCount = Math.max(
    ...orderedStages.map((st) => stageStats[st]?.count || 0),
  );

  // 5) States to control the drawer

  const [stageDrawerOpen, setStageDrawerOpen] = React.useState(false);
  const [selectedStage, setSelectedStage] = React.useState(null);
  const [stageInits, setStageInits] = React.useState([]);

  // 6) Click on the funnel bar

  const handleStageClick = (stage) => {
    const inThisStage = initiatives.filter(
      (init) =>
        (init.stage ? init.stage.toLowerCase() : "draft") ===
        stage.toLowerCase(),
    );
    setSelectedStage(stage);
    setStageInits(inThisStage);
    setStageDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setStageDrawerOpen(false);
    setSelectedStage(null);
    setStageInits([]);
  };

  return (
    <div style={{ padding: "16px" }}>
      <Typography
        variant="h5"
        style={{
          textDecoration: "none",
          fontWeight: "300",
          marginBottom: "25px",
          minHeight: "32px",
          textAlign: "center",
          fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
          "& small": {
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1",
          },
        }}
      >
        {t("whatshappening.table.stage_overview_title")}
      </Typography>

      {/* Funnel container aligned to the left of the card */}
      <div style={{ display: "flex", justifyContent: "flex-start" }}>
        <div style={{ width: "100%", maxWidth: "600px" }}>
          {orderedStages.map((stage, index) => {
            const { count, totalEbitda } = stageStats[stage] || {
              count: 0,
              totalEbitda: 0,
            };

            if (maxCount === 0) {
              return (
                <div key={stage} style={{ width: "100%", marginBottom: "8px" }}>
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      backgroundColor: "#f0f0f0",
                      padding: "14px",
                      borderRadius: "6px",
                    }}
                  >
                    {stage} (0)
                  </div>
                </div>
              );
            }

            // Width of bar proportional to count

            const percentage = Math.round((count / maxCount) * 100);
            const alpha = getAlphaForStage(index, orderedStages.length);
            const backgroundColor = `rgba(${baseR}, ${baseG}, ${baseB}, ${alpha})`;

            return (
              <div
                key={stage}
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  borderBottom:
                    index < orderedStages.length - 1
                      ? "1px dotted #ccc"
                      : "none",
                  paddingBottom: index < orderedStages.length - 1 ? "8px" : "0",
                  marginBottom: "8px",
                }}
              >
                {/* Centralized Funnel Bar */}
                <div
                  style={{ flex: 1, display: "flex", justifyContent: "center" }}
                >
                  <div
                    onClick={() => (count > 0 ? handleStageClick(stage) : null)}
                    style={{
                      width: `${percentage}%`,
                      backgroundColor,
                      padding: "14px 8px",
                      borderRadius: "6px",
                      transition: "width 0.3s ease-in-out",
                      color: "#fff",
                      boxShadow: "0 0 6px rgba(0,0,0,0.2)",
                      cursor: count > 0 ? "pointer" : "default",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    {stage} ({count})
                  </div>
                </div>
                {/* EBITDA INDICATOR OUT OF THE BAR */}
                <div
                  style={{
                    marginLeft: "8px",
                    minWidth: "100px",
                    textAlign: "right",
                  }}
                >
                  <Typography variant="body2" style={{ fontWeight: 500 }}>
                    CAPTURA: {Number(totalEbitda).toLocaleString()}
                  </Typography>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Drawer with listing of initiatives */}
      <Drawer
        anchor="right"
        open={stageDrawerOpen}
        onClose={handleCloseDrawer}
        BackdropProps={{ style: { backgroundColor: "#000", opacity: "0.1" } }}
        PaperProps={{
          style: {
            borderRadius: "10px",
            margin: "1vh 1vh 1vh 0",
            height: "98vh",
            width: "800px",
            padding: "10px",
          },
        }}
      >
        <Typography variant="h6" style={{ marginBottom: "12px" }}>
          {t("whatshappening.table.initiatives_in_stage")}{" "}
          <span style={{ textTransform: "capitalize" }}>{selectedStage}</span>
        </Typography>

        {stageInits.length > 0 ? (
          <>
            {stageInits
              .slice()
              .sort((a, b) => Number(b.ebitda) - Number(a.ebitda))
              .map((init) => (
                <div
                  key={init.id}
                  style={{
                    marginBottom: "10px",
                    padding: "8px",
                    borderRadius: "4px",
                    border: "1px solid #ddd",
                  }}
                >
                  <Typography style={{ fontWeight: 600 }}>
                    {init.initiativeName}
                  </Typography>
                  <Typography variant="body2" style={{ color: "#666" }}>
                    Branch: {init.branch} | Workfront: {init.workfront} |
                    CAPTURA: {Number(init.ebitda).toLocaleString()}
                  </Typography>
                </div>
              ))}

            {/* Totalizer */}
            <Box
              style={{
                borderTop: "1px solid #ccc",
                paddingTop: "8px",
                marginTop: "16px",
              }}
            >
              <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                Total CAPTURA:{" "}
                {stageInits
                  .reduce((sum, init) => sum + Number(init.ebitda || 0), 0)
                  .toLocaleString()}
              </Typography>
            </Box>
          </>
        ) : (
          <Typography variant="body2" style={{ color: "#aaa" }}>
            {t("whatshappening.table.no_initiatives")}
          </Typography>
        )}
      </Drawer>
    </div>
  );
}

// ---------------------------------------------

StageOverview.propTypes = {
  initiatives: PropTypes.array.isRequired,
};

// ============================ Main component ===========================

export default function CollapsibleStatusTable({
  selectedSection,
  viewModeOverview,
}) {
  const { userDetails } = useContext(AuthContext);
  const clientColor = userDetails?.implementation_color || "#2196f3";
  const { t } = useTranslation();

  // Styles

  const useDynamicStyles = (theme, clientColor) => ({
    ...styles(theme, clientColor),
    greenCircle: {
      width: circleSize,
      height: circleSize,
      borderRadius: "50%",
      background: "linear-gradient(135deg, #66bb6a 0%, #43a047 100%)",
      boxShadow: "0 0 10px rgba(67,160,71,0.4)",
      display: "inline-block",
      marginRight: 6,
    },
    yellowCircle: {
      width: circleSize,
      height: circleSize,
      borderRadius: "50%",
      background: "linear-gradient(135deg, #ffd54f 0%, #ffc107 100%)",
      boxShadow: "0 0 10px rgba(255,193,7,0.4)",
      display: "inline-block",
      marginRight: 6,
    },
    redCircle: {
      width: circleSize,
      height: circleSize,
      borderRadius: "50%",
      background: "linear-gradient(135deg, #ef5350 0%, #e53935 100%)",
      boxShadow: "0 0 10px rgba(229,57,53,0.4)",
      display: "inline-block",
      marginRight: 6,
    },
    drawer: {
      width: 400,
      padding: theme.spacing(1),
      position: "relative",
    },
    hoverCell: {
      position: "relative",
      overflow: "hidden",
      cursor: "pointer",
      "&::before": {
        content: "''",
        position: "absolute",
        top: 0,
        left: 0,
        width: "0%",
        height: "100%",
        backgroundColor: clientColor
          ? `${clientColor}1A`
          : "rgba(33, 150, 243, 0.05)",
        transition: "width 1s linear",
      },
      "&.filling::before": {
        animation: "$fillCell 1s linear forwards",
      },
    },
    "@keyframes fillCell": {
      "0%": { width: "0%" },
      "100%": { width: "100%" },
    },
    sortIcon: {
      fontSize: "14px",
      marginLeft: "6px",
      color: "#ccc",
    },
    activeSortIcon: {
      color: "#aaa",
    },
  });

  const useStyles = makeStyles((theme) => useDynamicStyles(theme, clientColor));
  const classes = useStyles();

  // Initial ordering

  const [sortConfig, setSortConfig] = useState({
    key: "status",
    direction: "ascending",
  });

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const sortedData = sortDataRecursively(mockData, sortConfig);

  // State for Drawer OnePage

  const [onePageDrawerOpen, setOnePageDrawerOpen] = useState(false);
  const [selectedOnePageInitiative, setSelectedOnePageInitiative] =
    useState(null);
  const [selectedOnePageDate, setSelectedOnePageDate] = useState("");

  const handleOpenOnePage = (initiativeRow) => {
    setSelectedOnePageInitiative(initiativeRow);
    const latestDate = getLatestOnePageDate(
      initiativeRow.id,
      selectedSection.start_date,
      selectedSection.end_date,
      onePageHistoryMock,
    );
    setSelectedOnePageDate(latestDate);
    setOnePageDrawerOpen(true);
  };

  const handleCloseOnePageDrawer = () => {
    setOnePageDrawerOpen(false);
    setSelectedOnePageInitiative(null);
  };

  return (
    <>
      {/* Se viewModeOverview === "table", renderiza a Tabela; senão, renderiza StageOverview */}
      {viewModeOverview === "table" ? (
        <TableContainer component={Paper}>
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell
                  onClick={() => handleSort("name")}
                  style={{ cursor: "pointer" }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {t("whatshappening.table.name")}
                    <FontAwesomeIcon
                      icon={
                        sortConfig.key === "name"
                          ? sortConfig.direction === "ascending"
                            ? faSortUp
                            : faSortDown
                          : faSort
                      }
                      className={
                        sortConfig.key === "name"
                          ? `${classes.sortIcon} ${classes.activeSortIcon}`
                          : classes.sortIcon
                      }
                    />
                  </div>
                </TableCell>
                <TableCell
                  align="center"
                  onClick={() => handleSort("initiatives")}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {t("whatshappening.table.number_initiatives")}
                    <FontAwesomeIcon
                      icon={
                        sortConfig.key === "initiatives"
                          ? sortConfig.direction === "ascending"
                            ? faSortUp
                            : faSortDown
                          : faSort
                      }
                      className={
                        sortConfig.key === "initiatives"
                          ? `${classes.sortIcon} ${classes.activeSortIcon}`
                          : classes.sortIcon
                      }
                    />
                  </div>
                </TableCell>
                <TableCell
                  align="right"
                  onClick={() => handleSort("ebitda")}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    {t("whatshappening.table.table_kpi")}
                    <FontAwesomeIcon
                      icon={
                        sortConfig.key === "ebitda"
                          ? sortConfig.direction === "ascending"
                            ? faSortUp
                            : faSortDown
                          : faSort
                      }
                      className={
                        sortConfig.key === "ebitda"
                          ? `${classes.sortIcon} ${classes.activeSortIcon}`
                          : classes.sortIcon
                      }
                    />
                  </div>
                </TableCell>
                <TableCell
                  align="center"
                  onClick={() => handleSort("status")}
                  style={{ cursor: "pointer" }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {t("whatshappening.table.status")}
                    <FontAwesomeIcon
                      icon={
                        sortConfig.key === "status"
                          ? sortConfig.direction === "ascending"
                            ? faSortUp
                            : faSortDown
                          : faSort
                      }
                      className={
                        sortConfig.key === "status"
                          ? `${classes.sortIcon} ${classes.activeSortIcon}`
                          : classes.sortIcon
                      }
                    />
                  </div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedData.map((branch) => (
                <Row
                  key={branch.name}
                  row={branch}
                  classes={classes}
                  onOpenOnePage={handleOpenOnePage}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        // If viewmodeOVeView === "Stages", render the vision of internships

        <StageOverview initiatives={flatInitiatives} />
      )}

      {/* DRAWER FOR ONEPAGE */}
      <Drawer
        anchor="bottom"
        open={onePageDrawerOpen}
        onClose={handleCloseOnePageDrawer}
        PaperProps={{
          style: {
            height: "70vh",
            overflowY: "auto",
            borderRadius: "10px",
            padding: "10px",
            backgroundColor: "#fafafa",
          },
        }}
      >
        {selectedOnePageInitiative && (
          <>
            <Typography variant="h6" style={{ marginBottom: "10px" }}>
              <span style={{ color: clientColor, fontWeight: "bold" }}>
                {selectedOnePageInitiative.name}
              </span>{" "}
              - {moment(selectedOnePageDate).format("LL")}
            </Typography>
            <OnePage
              selectedInitiative={selectedOnePageInitiative}
              selectedOnePageDate={selectedOnePageDate}
              onePageInfoMock={onePageInfoMock.filter(
                (op) =>
                  op.id === selectedOnePageInitiative.id &&
                  op.approved === "yes",
              )}
              onePageHistoryMock={onePageHistoryMock.filter(
                (h) => h.id === selectedOnePageInitiative.id,
              )}
              t={t}
              classes={classes}
              showContent={false}
            />
          </>
        )}
      </Drawer>
    </>
  );
}

CollapsibleStatusTable.propTypes = {
  selectedSection: PropTypes.shape({
    id: PropTypes.string.isRequired,
    section_name: PropTypes.string.isRequired,
    start_date: PropTypes.string.isRequired,
    end_date: PropTypes.string.isRequired,
    status: PropTypes.string,
    keyMessage: PropTypes.string,
  }).isRequired,
  viewModeOverview: PropTypes.oneOf(["table", "stages"]).isRequired,
};
